/**
 * Created by WorkAxis www.workaxis.in
 * Products page — AntCRM and client case studies.
 */
import React from 'react';
import "./style.css";
import {antcrmFeatures, antcrmProofPoints, clientWork, clients} from "./data";
import {PageHero, CtaSection, LogoMarquee, SectionHead} from "./shared";
import {Magnetic, Parallax, Reveal, ScrollGrow, TiltCard} from "./motion";
import WiloShowcase from "./WiloShowcase";

function CaseStudyCard({item, index}) {
    return (
        <Reveal as="article" className="wx-case-study" delay={index * 0.08}>
            <a href={item.link} target="_blank" rel="noreferrer" className="wx-case-study-media">
                <img loading="lazy" src={item.image} alt={item.name}/>
            </a>
            <div className="wx-case-study-body">
                <h3>
                    <a href={item.link} target="_blank" rel="noreferrer">{item.name}</a>
                </h3>
                <dl className="wx-case-dl">
                    <div>
                        <dt>Problem</dt>
                        <dd>{item.problem}</dd>
                    </div>
                    <div>
                        <dt>What we built</dt>
                        <dd>{item.built}</dd>
                    </div>
                    <div>
                        <dt>Technology</dt>
                        <dd>
                            <div className="wx-chip-row">
                                {item.tech.map((t) => <span className="wx-chip is-small" key={t}>{t}</span>)}
                            </div>
                        </dd>
                    </div>
                    <div>
                        <dt>Outcome</dt>
                        <dd>{item.outcome}</dd>
                    </div>
                    <div>
                        <dt>Ownership</dt>
                        <dd className="wx-case-ownership-value">{item.ownership}</dd>
                    </div>
                </dl>
            </div>
        </Reveal>
    );
}

export default function Products() {
    return (
        <div>
            <PageHero
                kicker="Products & Work"
                title={<>Built with <span className="wx-grad-text">end-to-end ownership.</span></>}
                lead="We are a product company as much as a services partner. Case studies below show the
                      problem, what we owned, and what shipped — the same discipline we apply to AntCRM and Wilo."
            />

            {/* ---------- AntCRM ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <ScrollGrow className="wx-product-featured">
                        <div className="wx-product-featured-body">
                            <div className="wx-product-tag">Flagship Product</div>
                            <h3>AntCRM</h3>
                            <p>
                                A customer relationship platform designed, engineered, and operated entirely
                                in-house — proof that we build and run real products, not just client projects.
                            </p>
                            <ul className="wx-product-points">
                                {antcrmProofPoints.map((p) => <li key={p}>{p}</li>)}
                            </ul>
                            <Magnetic>
                                <a href="https://antcrm.co" target="_blank" rel="noreferrer"
                                   className="wx-btn wx-btn-primary">Explore AntCRM</a>
                            </Magnetic>
                        </div>
                        <div className="wx-product-featured-visual">
                            <Parallax speed={28}>
                                <div className="wx-ant-mark">
                                    <div className="wx-ant-logo wx-grad-text">AntCRM</div>
                                    <div className="wx-ant-domain">antcrm.co</div>
                                </div>
                            </Parallax>
                        </div>
                    </ScrollGrow>

                    <div className="wx-services-grid is-four">
                        {antcrmFeatures.map((f, i) => (
                            <TiltCard key={f.name} className="wx-service-card" delay={(i % 4) * 0.08}>
                                <div className="wx-service-title">{f.name}</div>
                                <div className="wx-service-desc">{f.desc}</div>
                            </TiltCard>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Wilo ---------- */}
            <section className="wx-section wx-section-tight" id="wilo">
                <div className="wx-container">
                    <WiloShowcase withFeatures/>
                </div>
            </section>

            {/* ---------- Client work ---------- */}
            <section className="wx-section">
                <div className="wx-container">
                    <SectionHead kicker="Case studies" title="Products we've built with partners."/>
                    <div className="wx-case-studies">
                        {clientWork.map((item, i) => (
                            <CaseStudyCard key={item.name} item={item} index={i}/>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Clients ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <SectionHead kicker="Trusted by" center/>
                </div>
                <LogoMarquee logos={clients}/>
            </section>

            <CtaSection
                title={<>Have a process that's <span className="wx-grad-text">hard to scale?</span></>}
                text="Share your workflow — we'll suggest what can realistically be automated or built."
                primaryLabel="Get a solution assessment"
            />
        </div>
    );
}
